(function(){
  /* ── Helpers ──────────────────────────────────────────────────────────── */
  function getJson(attr){
    var el=document.querySelector('['+attr+']');
    if(!el)return null;
    try{return JSON.parse(el.textContent)}catch(e){return null}
  }
  // Global shared data — configured once, used by every section on every page
  var _globalData=null;
  function getGlobalData(){
    if(_globalData!==null)return _globalData;
    var el=document.getElementById('kb-global-data');
    if(!el){_globalData={};return _globalData;}
    try{_globalData=JSON.parse(el.textContent);}catch(e){_globalData={};}
    return _globalData;
  }
  function fmt(cents){return '$'+(cents/100).toFixed(2)}
  function esc(str){return String(str||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;')}
  function rand(min,max){return Math.floor(Math.random()*(max-min+1))+min}

  /* ── SVG Icons ────────────────────────────────────────────────────────── */
  var ICONS={
    checkmark:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    shield:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>',
    star:'<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    bolt:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    headset:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/></svg>',
    lock:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
    users:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>',
    shipping:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    fire:'<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>'
  };

  /* ── 1. Urgency Bar (Scrolling Marquee) ─────────────────────────────── */
  function renderUrgency(){
    var shell=document.getElementById('scaled-urgency');
    if(!shell)return;
    var d=shell.dataset;
    var tagline=d.tagline||'Best Vendors In The Game';
    var rating=d.rating||'4.98/5';
    var custCount=d.customers||'10,247';
    var showCountdown=d.showCountdown!=='false';
    var countdownHours=parseInt(d.countdownHours)||24;
    var countdownLabel=d.countdownLabel||'Price increasing in';
    var viewerMin=parseInt(d.viewerMin)||60;
    var viewerMax=parseInt(d.viewerMax)||120;
    var speed=parseInt(d.speed)||40;
    var viewerCount=rand(viewerMin,viewerMax);
    var viewerLabel=d.viewerLabel||'live viewers';
    var customerLabel=d.customerLabel||'happy customers';
    var ratingLabel=d.ratingLabel||'Rated';
    // v2: appearance + per-item show toggles
    var bgColor=d.bgColor||'';
    var textColor=d.textColor||'';
    var fontSize=parseInt(d.fontSize)||14;
    var showTagline=d.showTagline!=='false';
    var showRating=d.showRating!=='false';
    var showViewers=d.showViewers!=='false';
    var showCustomers=d.showCustomers!=='false';
    var showIcons=d.showIcons!=='false';
    var showViewer2=d.showViewer2==='true';
    var viewerLabel2=d.viewerLabel2||'watching now';
    var viewerMin2=parseInt(d.viewerMin2)||60;
    var viewerMax2=parseInt(d.viewerMax2)||120;
    var viewerCount2=rand(viewerMin2,viewerMax2);

    var cdKey='kb_cd_end';
    var cdEnd=parseInt(sessionStorage.getItem(cdKey)||'0');
    if(!cdEnd||cdEnd<=Date.now()){
      cdEnd=Date.now()+(countdownHours*3600*1000);
      sessionStorage.setItem(cdKey,String(cdEnd));
    }
    function fmtCountdown(){
      var diff=Math.max(0,cdEnd-Date.now());
      var h=Math.floor(diff/3600000);
      var m=Math.floor((diff%3600000)/60000);
      var sec=Math.floor((diff%60000)/1000);
      return (h>0?h+':':'')+(h>0?String(m).padStart(2,'0'):m)+':'+String(sec).padStart(2,'0');
    }

    var dot='<span class="kb-uq__dot"> · </span>';
    function makeInner(){
      var items=[
        (showTagline&&tagline?'<span class="kb-uq__tagline">'+esc(tagline)+'</span>':null),
        (showRating&&rating?'<span class="kb-uq__rated">'+esc(ratingLabel)+' <strong>'+esc(rating)+'</strong></span>':null),
        (showRating&&rating?'<span class="kb-uq__stars">'+(showIcons?'&#9733;&#9733;&#9733;&#9733;&#9733;':'')+'</span>':null),
        (showViewers&&viewerLabel?'<span class="kb-uq__viewers">'+(showIcons?'<span class="kb-uq__live-dot"></span>':'')+'<span id="kb-uq-vc">'+viewerCount+'</span> '+esc(viewerLabel)+'</span>':null),
        (showViewer2&&viewerLabel2?'<span class="kb-uq__viewers">'+(showIcons?'<span class="kb-uq__live-dot--red"></span>':'')+'<span id="kb-uq-vc2">'+viewerCount2+'</span> '+esc(viewerLabel2)+'</span>':null),
        (showCountdown&&countdownLabel?'<span class="kb-uq__cd">'+esc(countdownLabel)+': <strong id="kb-uq-timer">'+fmtCountdown()+'</strong></span>':null),
        (showCustomers&&custCount?'<span class="kb-uq__customers"><strong>'+esc(custCount)+'</strong> '+esc(customerLabel)+'</span>':null)
      ];
      return '<div class="kb-uq__inner">'+items.filter(Boolean).join(dot)+dot+'</div>';
    }

    var styleStr='--uq-speed:'+speed+'s;font-size:'+fontSize+'px;'+(bgColor?'background:'+bgColor+';':'')+(textColor?'color:'+textColor+';':'');
    var inner=makeInner();
    shell.innerHTML=
      '<div class="kb-uq" style="'+styleStr+'">'+
        '<div class="kb-uq__track">'+inner+inner+'</div>'+
      '</div>';

    // Guard: clear old intervals if section re-renders (e.g., theme editor)
    if(shell._kbTimers){shell._kbTimers.forEach(function(id){clearInterval(id)});}
    shell._kbTimers=[];
    if(showCountdown){
      shell._kbTimers.push(setInterval(function(){
        var el=document.getElementById('kb-uq-timer');
        if(el)el.textContent=fmtCountdown();
      },1000));
    }
    var viewerRefreshMs=(parseInt(d.viewerRefresh)||4)*1000;
    shell._kbTimers.push(setInterval(function(){
      var el=document.getElementById('kb-uq-vc');
      if(!el)return;
      viewerCount=Math.max(viewerMin,Math.min(viewerMax,viewerCount+rand(-3,4)));
      el.textContent=viewerCount;
    },viewerRefreshMs));
    if(showViewer2){
      shell._kbTimers.push(setInterval(function(){
        var el2=document.getElementById('kb-uq-vc2');
        if(!el2)return;
        viewerCount2=Math.max(viewerMin2,Math.min(viewerMax2,viewerCount2+rand(-3,4)));
        el2.textContent=viewerCount2;
      },viewerRefreshMs));
    }
  }

    /* ── 2. Trust Bar ────────────────────────────────────────────────────── */
  function renderTrustBar(){
    var shell=document.getElementById('scaled-trust-bar');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="trust-bar"');
    if(!s)return;
    var badges=s.badges||[];
    if(!badges.length)return;
    var speed=s.animationSpeed||15;
    // v2: color, size, divider, padding settings
    var bgColor=s.bgColor||'';
    var textColor=s.textColor||'';
    var iconColor=s.iconColor||textColor||'';
    var iconSize=parseInt(s.iconSize)||16;
    var fontSize=parseInt(s.fontSize)||14;
    var dividerStyle=s.dividerStyle||'dot';
    var paddingMap={compact:'4px 10px',normal:'4px 16px',spacious:'4px 24px'};
    var itemPadding=paddingMap[s.padding||'normal']||'4px 16px';
    var dividerChars={dot:'·',pipe:'|',slash:'/',none:''};
    var dividerChar=dividerChars[dividerStyle]!==undefined?dividerChars[dividerStyle]:'·';
    var sep=(s.showSeparator!==false&&dividerChar)?'<span class="kb-trust__sep">'+dividerChar+'</span>':'';
    var badgeStyle='padding:'+itemPadding+';font-size:'+fontSize+'px;'+(textColor?'color:'+textColor+';':'');
    var iconStyleAttr=iconColor?'style="color:'+iconColor+'"':'';
    function makeBadge(b){
      var svgIcon=b.iconType&&b.iconType!=='none'&&ICONS[b.iconType]
        ?ICONS[b.iconType].replace('<svg ','<svg '+iconStyleAttr+' width="'+iconSize+'" height="'+iconSize+'" ')
        :'';
      var icon=svgIcon?'<span class="kb-trust__icon">'+svgIcon+'</span>':'';
      var img=b.customIcon?'<img src="'+esc(b.customIcon)+'" class="kb-trust__custom-icon" alt="" style="height:'+iconSize+'px;width:'+iconSize+'px">':'';
      return '<span class="kb-trust__badge" style="'+badgeStyle+'">'+(img||icon)+'<span>'+esc(b.text)+'</span></span>';
    }
    var track=badges.map(function(b){return makeBadge(b)+sep}).join('')+badges.map(function(b){return makeBadge(b)+sep}).join('');
    shell.innerHTML=
      '<div class="kb-trust"'+(bgColor?' style="background:'+bgColor+'"':'')+'>'+
        '<div class="kb-trust__track">'+track+'</div>'+
      '</div>';

    // CSS compositor animation — runs off main thread, always smooth.
    // Use pixel values (not -50%) to avoid sub-pixel rounding reset flash.
    // Apply bar height to the trust bar container
    var barHeight=parseInt(s.barHeight)||44;
    var trustEl=shell.querySelector('.kb-trust');
    if(trustEl){trustEl.style.minHeight=barHeight+'px';trustEl.style.display='flex';trustEl.style.alignItems='center';}
    var trackEl=shell.querySelector('.kb-trust__track');
    if(trackEl){
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          var halfPx=Math.round(trackEl.scrollWidth/2);
          if(!halfPx)return;
          var styleId='kb-trust-kf';
          var ex=document.getElementById(styleId);
          if(ex)ex.remove();
          var kf=document.createElement('style');
          kf.id=styleId;
          kf.textContent='@keyframes kb-trust-t3d{0%{transform:translate3d(0,0,0)}to{transform:translate3d(-'+halfPx+'px,0,0)}}';
          document.head.appendChild(kf);
          trackEl.style.cssText='animation:kb-trust-t3d '+speed+'s linear infinite;will-change:transform';
        });
      });
    }
  }

  /* ── 3. Testimonials ─────────────────────────────────────────────────── */
  function renderTestimonials(){
    var shell=document.getElementById('scaled-testimonials');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="testimonials"');
    if(!s)s={};
    var gd=getGlobalData();
    // Use global testimonials if set, otherwise fall back to section-level images
    var images=(gd.testimonials&&gd.testimonials.length)?gd.testimonials:(s.images||[]);
    var speed=s.animationSpeed||20;
    var h=s.imageHeight||400;
    var itemW=s.carouselItemWidth||280;
    var rawHeadline=s.headline||'What Our Customers Say';
    var hw=s.highlightWord||'';
    var headline=hw?(function(){var re=new RegExp('('+hw.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+')','i');return rawHeadline.replace(re,'<span class="kb-highlight">$1</span>');})():esc(rawHeadline);
    var subLabelSize=parseInt(s.subHeadlineSize)||12;
    var subHeadline=s.subHeadline?'<p class="kb-testi__sub-label" style="font-size:'+subLabelSize+'px">'+esc(s.subHeadline)+'</p>':'';
    var displayMode=s.displayMode||'auto-scroll';
    var testiUseHeadingFont=s.useHeadingFont===true;
    var testiTitleSize=parseInt(s.heroTitleSize)||40;
    var testiTitleCase=s.heroTitleCase||'uppercase';
    var testiTitleStyle=testiUseHeadingFont?'font-size:'+testiTitleSize+'px;font-weight:900;text-transform:'+testiTitleCase+';letter-spacing:-1px;line-height:1.05;':'';
    if(!images.length){shell.style.display='none';return}

    // Build a media item (image or video)
    function makeItem(img,id){
      var content='';
      var isDirectVideo=false;
      var vid=img.videoUrl||'';
      if(vid){
        // YouTube
        var ytMatch=vid.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
        if(ytMatch){
          content='<iframe src="https://www.youtube.com/embed/'+ytMatch[1]+'?rel=0&modestbranding=1" frameborder="0" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowfullscreen style="width:100%;height:'+h+'px;border-radius:8px"></iframe>';
        } else if(vid.indexOf('tiktok.com')!==-1){
          // TikTok — extract video id
          var ttMatch=vid.match(/tiktok\.com\/@[^/]+\/video\/(\d+)/);
          var ttId=ttMatch?ttMatch[1]:'';
          if(ttId){
            content='<iframe src="https://www.tiktok.com/embed/v2/'+ttId+'" frameborder="0" allowfullscreen style="width:100%;height:'+h+'px;border-radius:8px"></iframe>';
          } else {
            content='<video src="'+esc(vid)+'" style="width:100%;height:'+h+'px;object-fit:cover;border-radius:8px" muted autoplay loop playsinline></video>';
            isDirectVideo=true;
          }
        } else if(/\.(mp4|webm|ogg)(\?|$)/i.test(vid)){
          content='<video src="'+esc(vid)+'" style="width:100%;height:'+h+'px;object-fit:cover;border-radius:8px" muted autoplay loop playsinline></video>';
          isDirectVideo=true;
        } else if(img.url){
          content='<img src="'+esc(img.url)+'" alt="'+esc(img.alt||'')+'" style="height:'+h+'px;object-fit:cover;border-radius:8px" loading="eager">';
        }
      } else if(img.url){
        content='<img src="'+esc(img.url)+'" alt="'+esc(img.alt||'')+'" style="height:'+h+'px;object-fit:cover;border-radius:8px" loading="eager">';
      }
      if(!content) return '';
      var ICON_MUTED='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
      var muteBtn=isDirectVideo?'<button class="kb-testi__mute-btn" onclick="kbMuteToggle(this)" aria-label="Unmute">'+ICON_MUTED+'</button>':'';
      var caption=img.caption?'<div class="kb-testi__caption">'+esc(img.caption)+'</div>':'';
      return '<div class="kb-testi__item" id="kb-testi-item-'+(id!==undefined?id:'')+'" style="width:'+itemW+'px;height:'+h+'px;transition:height .35s ease,width .35s ease">'+content+muteBtn+caption+'</div>';
    }

    if(displayMode==='carousel'){
      // Carousel: all items visible in a scrollable row, arrows below
      var carouselItems=images.map(makeItem).join('');
      shell.innerHTML=
        '<div class="kb-testi kb-testi--carousel">'+
          '<h2 class="kb-section-title" style="'+testiTitleStyle+'">'+headline+'</h2>'+
          subHeadline+
          '<div class="kb-testi__carousel-vp" id="kb-testi-vp">'+
            '<div class="kb-testi__track kb-testi__track--static">'+carouselItems+'</div>'+
          '</div>'+
          '<div class="kb-testi__carousel-controls">'+
            '<button class="kb-testi__arrow kb-testi__arrow--prev" id="kb-testi-prev" aria-label="Previous">'+
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'+
            '</button>'+
            '<button class="kb-testi__arrow kb-testi__arrow--next" id="kb-testi-next" aria-label="Next">'+
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'+
            '</button>'+
          '</div>'+
        '</div>';
      var vp=document.getElementById('kb-testi-vp');
      function carouselScroll(dir){
        var item=vp.querySelector('.kb-testi__item');
        if(item){vp.scrollBy({left:dir*(item.offsetWidth+12),behavior:'smooth'})}
      }
      document.getElementById('kb-testi-prev').addEventListener('click',function(){carouselScroll(-1);setTimeout(updateActive,400)});
      document.getElementById('kb-testi-next').addEventListener('click',function(){carouselScroll(1);setTimeout(updateActive,400)});
      // Active item: expand the centered item's height
      var activeH=Math.round(h*1.18);
      function updateActive(){
        var vpRect=vp.getBoundingClientRect();
        var vpCx=vpRect.left+vpRect.width/2;
        var allItems=vp.querySelectorAll('.kb-testi__item');
        var closest=null,minD=Infinity;
        allItems.forEach(function(item){var r=item.getBoundingClientRect();var d=Math.abs((r.left+r.width/2)-vpCx);if(d<minD){minD=d;closest=item}});
        allItems.forEach(function(item){
          item.style.height=h+'px';
          var m=item.querySelector('video,img,iframe');if(m)m.style.height=h+'px';
          var v=item.querySelector('video');if(v)v.muted=true;
        });
        if(closest){
          closest.style.height=activeH+'px';
          var m=closest.querySelector('video,img,iframe');if(m)m.style.height=activeH+'px';
          if(window.kbCarousel&&window.kbCarousel.audioOn){var v=closest.querySelector('video');if(v)v.muted=false;}
        }
      }
      window.kbCarousel={audioOn:false,updateActive:updateActive};
      var _uaDebounce;
      vp.addEventListener('scroll',function(){clearTimeout(_uaDebounce);_uaDebounce=setTimeout(updateActive,120);},{passive:true});
      setTimeout(updateActive,80);
    } else if(displayMode==='arrow-nav'){
      // Single-item arrow nav (legacy)
      var arrowItems=images.map(function(img,i){return makeItem(img,i)}).join('');
      shell.innerHTML=
        '<div class="kb-testi kb-testi--arrow">'+
          '<h2 class="kb-section-title" style="'+testiTitleStyle+'">'+headline+'</h2>'+
          subHeadline+
          '<div class="kb-testi__arrow-wrap">'+
            '<button class="kb-testi__arrow kb-testi__arrow--prev" id="kb-testi-prev" aria-label="Previous">'+
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>'+
            '</button>'+
            '<div class="kb-testi__arrow-viewport">'+arrowItems+'</div>'+
            '<button class="kb-testi__arrow kb-testi__arrow--next" id="kb-testi-next" aria-label="Next">'+
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>'+
            '</button>'+
          '</div>'+
          '<div class="kb-testi__dots" id="kb-testi-dots">'+
            images.map(function(_,i){return '<button class="kb-testi__dot'+(i===0?' is-active':'')+'" data-idx="'+i+'" aria-label="Go to '+(i+1)+'">'+(i+1)+'</button>'}).join('')+
          '</div>'+
        '</div>';
      var items=shell.querySelectorAll('.kb-testi__item');
      var dots=shell.querySelectorAll('.kb-testi__dot');
      var cur=0;
      function showSlide(n){
        cur=(n+images.length)%images.length;
        items.forEach(function(el,i){el.style.display=i===cur?'block':'none'});
        dots.forEach(function(d,i){d.classList.toggle('is-active',i===cur)});
      }
      showSlide(0);
      document.getElementById('kb-testi-prev').addEventListener('click',function(){showSlide(cur-1)});
      document.getElementById('kb-testi-next').addEventListener('click',function(){showSlide(cur+1)});
      dots.forEach(function(d){d.addEventListener('click',function(){showSlide(parseInt(d.getAttribute('data-idx')))})});
      items.forEach(function(item){item.addEventListener('click',function(){showSlide(cur+1)});item.style.cursor='pointer'});
    } else {
      // Auto-scroll marquee mode (default)
      var track=images.map(makeItem).join('')+images.map(makeItem).join('');
      shell.innerHTML=
        '<div class="kb-testi">'+
          '<h2 class="kb-section-title" style="'+testiTitleStyle+'">'+headline+'</h2>'+
          subHeadline+
          '<div class="kb-testi__viewport">'+
            '<div class="kb-testi__track" id="kb-testi-track" style="--testi-speed:'+speed+'s">'+track+'</div>'+
          '</div>'+
        '</div>';
      // Pause animation when section is not visible (saves CPU/GPU)
      if('IntersectionObserver' in window){
        var trackEl=document.getElementById('kb-testi-track');
        if(trackEl){
          new IntersectionObserver(function(entries){
            entries.forEach(function(e){
              trackEl.style.animationPlayState=e.isIntersecting?'running':'paused';
            });
          },{threshold:0}).observe(shell);
        }
      }
    }
    // iOS Safari: remove the muted HTML attribute so JS can toggle .muted via user gesture
    shell.querySelectorAll('video').forEach(function(v){v.removeAttribute('muted');v.muted=true});
  }

  window.kbMuteToggle=function(btn){
    var item=btn.closest('.kb-testi__item');
    var v=item?item.querySelector('video'):null;
    var ICON_MUTED='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
    var ICON_UNMUTED='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>';
    var kbc=window.kbCarousel;
    if(kbc){
      kbc.audioOn=!kbc.audioOn;
      kbc.updateActive();
      document.querySelectorAll('.kb-testi__mute-btn').forEach(function(b){
        b.innerHTML=kbc.audioOn?ICON_UNMUTED:ICON_MUTED;
        b.setAttribute('aria-label',kbc.audioOn?'Mute':'Unmute');
      });
    } else {
      if(!v)return;
      v.muted=!v.muted;
      btn.innerHTML=v.muted?ICON_MUTED:ICON_UNMUTED;
      btn.setAttribute('aria-label',v.muted?'Unmute':'Mute');
    }
  };

  /* ── 4. FAQ ──────────────────────────────────────────────────────────── */
  function renderFaq(){
    var shell=document.getElementById('scaled-faq');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="faq"');
    if(!s)s={};
    var gd=getGlobalData();
    // Use global FAQs if set, otherwise fall back to section-level blocks
    if(gd.faqs&&gd.faqs.length)s.faqs=gd.faqs;
    if(!s.faqs||!s.faqs.length){shell.style.display='none';return}
    var faqUseHeadingFont=s.useHeadingFont===true;
    var faqTitleSize=parseInt(s.heroTitleSize)||40;
    var faqTitleCase=s.heroTitleCase||'uppercase';
    var faqTitleStyle=faqUseHeadingFont?'font-size:'+faqTitleSize+'px;font-weight:900;text-transform:'+faqTitleCase+';letter-spacing:-1px;line-height:1.05;':'';
    var items=s.faqs.map(function(f,i){
      return '<div class="kb-faq__item">'+
        '<button class="kb-faq__q" aria-expanded="false" onclick="kbFaqToggle(this,'+i+')">'+
          '<span>'+esc(f.question)+'</span>'+
          '<span class="kb-faq__arrow">'+ICONS.bolt+'</span>'+
        '</button>'+
        '<div class="kb-faq__a" id="kb-faq-'+i+'">'+
          '<div class="kb-faq__a-inner">'+esc(f.answer)+'</div>'+
        '</div>'+
      '</div>';
    }).join('');
    shell.innerHTML=
      '<div class="kb-faq">'+
        '<h2 class="kb-section-title" style="'+faqTitleStyle+'">'+esc(s.heading||'Frequently Asked Questions')+'</h2>'+
        '<div class="kb-faq__list">'+items+'</div>'+
      '</div>';
    shell.classList.remove('scaled-shell--loading');
    window.kbFaqToggle=function(btn,i){
      var expanded=btn.getAttribute('aria-expanded')==='true';
      // Close all
      shell.querySelectorAll('.kb-faq__q').forEach(function(b){b.setAttribute('aria-expanded','false');b.classList.remove('is-open')});
      shell.querySelectorAll('.kb-faq__a').forEach(function(a){a.style.maxHeight=null});
      if(!expanded){
        btn.setAttribute('aria-expanded','true');
        btn.classList.add('is-open');
        var ans=document.getElementById('kb-faq-'+i);
        if(ans)ans.style.maxHeight=ans.scrollHeight+'px';
      }
    };
  }

  /* ── 5. Live Sales Notifications ─────────────────────────────────────── */
  function renderLiveSales(){
    var shell=document.getElementById('scaled-live-sales');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="live-sales"');
    var products=getJson('data-scaled-products="live-sales"');
    if(!s||!products||!products.length)return;
    shell.style.display='none';
    var pos=s.position||'bottom-left';
    var nameColor=s.name_color||'#CC3D3D';
    var displayDur=(s.display_duration||7)*1000;
    var minDelay=(s.min_delay||8)*1000;
    var maxDelay=(s.max_delay||20)*1000;
    var initDelay=(s.initial_delay||5)*1000;
    var firstNames=['Emma','Liam','Sofia','Noah','Olivia','Ethan','Ava','Mason','Isabella','Lucas','Mia','Aiden','Amelia','James','Harper','Alexander','Evelyn','Sebastian','Abigail','Michael','Emily'];
    var locations=['New York, NY','Los Angeles, CA','Chicago, IL','Houston, TX','Phoenix, AZ','Philadelphia, PA','San Antonio, TX','San Diego, CA','Dallas, TX','San Jose, CA','Austin, TX','Miami, FL','Atlanta, GA','Boston, MA','Seattle, WA','Denver, CO'];
    var times=['just now','2 minutes ago','5 minutes ago','8 minutes ago','12 minutes ago','20 minutes ago','an hour ago'];
    var popup=document.createElement('div');
    popup.className='kb-live-sales kb-live-sales--'+pos;
    popup.style.display='none';
    document.body.appendChild(popup);
    function showNotif(){
      var product=products[rand(0,products.length-1)];
      var name=firstNames[rand(0,firstNames.length-1)];
      var loc=locations[rand(0,locations.length-1)];
      var time=times[rand(0,times.length-1)];
      popup.innerHTML=
        '<div class="kb-live-sales__inner">'+
          '<div class="kb-live-sales__icon">'+ICONS.fire+'</div>'+
          '<div class="kb-live-sales__text">'+
            '<strong style="color:'+esc(nameColor)+'">'+esc(name)+'</strong> from <em>'+esc(loc)+'</em><br>'+
            'purchased <strong>'+esc(product)+'</strong><br>'+
            '<span class="kb-live-sales__time">'+esc(time)+'</span>'+
          '</div>'+
          '<button class="kb-live-sales__close" onclick="this.parentElement.parentElement.style.display=\'none\'">×</button>'+
        '</div>';
      popup.style.display='block';
      popup.classList.add('is-visible');
      setTimeout(function(){
        popup.classList.remove('is-visible');
        setTimeout(function(){popup.style.display='none'},400);
        scheduleNext();
      },displayDur);
    }
    function scheduleNext(){
      setTimeout(showNotif,rand(minDelay,maxDelay));
    }
    setTimeout(function(){showNotif();},initDelay);
  }

  /* ── 6. AI Chat Widget ───────────────────────────────────────────────── */
  function renderChat(){
    var shell=document.getElementById('scaled-chat');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="chat"');
    if(!s)s={};
    var cfg=window.ScaledConfig||{};
    var chatCfg=cfg.chatbot||{};
    var name=esc(s.name||chatCfg.name||'Reselling Assistant');
    var greeting=esc(s.greeting||chatCfg.context||"Hey! Got questions? I'm here to help.");
    var pos=s.position||'bottom-right';
    shell.style.display='none';
    var widget=document.createElement('div');
    widget.className='kb-chat kb-chat--'+pos;
    widget.innerHTML=
      '<button class="kb-chat__toggle" id="kb-chat-toggle" aria-label="Open chat">'+
        '<div class="kb-chat__toggle-icon">'+
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>'+
        '</div>'+
        (s.showPulse!==false?'<span class="kb-chat__pulse"></span>':'')+
      '</button>'+
      '<div class="kb-chat__window" id="kb-chat-window" style="display:none">'+
        '<div class="kb-chat__header">'+
          '<div class="kb-chat__header-info">'+
            '<span class="kb-chat__online-dot"></span>'+
            '<div>'+
              '<div class="kb-chat__name">'+name+'</div>'+
              '<div class="kb-chat__status">Online now</div>'+
            '</div>'+
          '</div>'+
          '<button class="kb-chat__close" id="kb-chat-close">×</button>'+
        '</div>'+
        '<div class="kb-chat__messages" id="kb-chat-messages">'+
          '<div class="kb-chat__msg kb-chat__msg--bot">'+
            '<div class="kb-chat__bubble">'+greeting+'</div>'+
          '</div>'+
        '</div>'+
        '<div class="kb-chat__input-wrap">'+
          '<input type="text" class="kb-chat__input" id="kb-chat-input" placeholder="Type your question...">'+
          '<button class="kb-chat__send" id="kb-chat-send">'+
            '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>'+
          '</button>'+
        '</div>'+
      '</div>';
    document.body.appendChild(widget);
    var toggle=document.getElementById('kb-chat-toggle');
    var win=document.getElementById('kb-chat-window');
    var close=document.getElementById('kb-chat-close');
    var input=document.getElementById('kb-chat-input');
    var send=document.getElementById('kb-chat-send');
    var msgs=document.getElementById('kb-chat-messages');
    function openChat(){win.style.display='flex';toggle.style.display='none';input.focus()}
    function closeChat(){win.style.display='none';toggle.style.display='flex'}
    toggle.addEventListener('click',openChat);
    close.addEventListener('click',closeChat);
    var botReplies=["That's a great question! Our product is top quality and used by thousands of satisfied customers.","Yes absolutely! We offer a 30-day money-back guarantee, no questions asked.","Shipping is fast — most orders arrive within 3-5 business days.","Feel free to reach out to our support team for more details. We're happy to help!","Our customers love it! Check out the reviews section for real feedback."];
    function addMsg(text,isBot){
      var div=document.createElement('div');
      div.className='kb-chat__msg'+(isBot?' kb-chat__msg--bot':'');
      div.innerHTML='<div class="kb-chat__bubble">'+esc(text)+'</div>';
      msgs.appendChild(div);
      msgs.scrollTop=msgs.scrollHeight;
    }
    function sendMsg(){
      var val=input.value.trim();
      if(!val)return;
      addMsg(val,false);
      input.value='';
      // Typing indicator
      var typing=document.createElement('div');
      typing.className='kb-chat__msg kb-chat__msg--bot kb-chat__typing';
      typing.innerHTML='<div class="kb-chat__bubble"><span></span><span></span><span></span></div>';
      msgs.appendChild(typing);
      msgs.scrollTop=msgs.scrollHeight;
      setTimeout(function(){
        typing.remove();
        addMsg(botReplies[rand(0,botReplies.length-1)],true);
      },1200+rand(0,800));
    }
    send.addEventListener('click',sendMsg);
    input.addEventListener('keydown',function(e){if(e.key==='Enter')sendMsg()});
  }

  /* ── 7. Customer Reviews ─────────────────────────────────────────────── */
  function renderReviews(){
    var shell=document.getElementById('scaled-reviews');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="reviews"');
    if(!s)s={};
    var rawTitle=s.title||'Customer Reviews';
    var thw=s.highlightWord||'';
    var title=thw?(function(){var re=new RegExp('('+thw.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+')','i');return rawTitle.replace(re,'<span class="kb-highlight">$1</span>');})():esc(rawTitle);
    var subtitle=esc(s.subtitle||'');
    // Global shared data takes priority over per-section blocks
    var gd=getGlobalData();
    var globalReviews=gd.reviews&&Array.isArray(gd.reviews.items)?gd.reviews.items:[];
    // Merge image defaults: global section settings → local section settings
    if(gd.reviews&&gd.reviews.defaultImageSize&&!s.defaultImageSize)s.defaultImageSize=gd.reviews.defaultImageSize;
    if(gd.reviews&&gd.reviews.defaultImagePosition&&!s.defaultImagePosition)s.defaultImagePosition=gd.reviews.defaultImagePosition;
    // Use global reviews if any exist, otherwise fall back to section blocks
    var adminReviews=globalReviews.length?globalReviews:(Array.isArray(s.adminReviews)?s.adminReviews:[]);
    // Customer reviews stored in localStorage (device-specific, appended after admin reviews)
    var localReviews=[];
    try{localReviews=JSON.parse(localStorage.getItem('kb_reviews')||'[]')}catch(e){}
    // Merge: admin reviews first (always visible), then local ones
    var stored=adminReviews.concat(localReviews);
    function renderStars(n){
      var html='';
      for(var i=1;i<=5;i++)html+='<svg width="14" height="14" viewBox="0 0 24 24" fill="'+(i<=n?'#FFD700':'#444')+'" style="display:inline"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
      return html;
    }
    var IMG_SIZE={small:72,medium:130,large:200};
    var KB_PAGE_SIZE=parseInt(s.reviewsPerPage)||10;
    var kbVisibleCount=KB_PAGE_SIZE;
    var verifiedLabel=s.verifiedBadgeLabel||'Verified Buyer';
    var gridLayout=s.gridLayout||'list';
    var innerGap=parseInt(s.innerGap)||8;
    var useHeadingFont=s.useHeadingFont===true;
    var reviewFontSize=parseInt(s.reviewFontSize)||0;
    var sectionAlign=s.sectionAlign||'left';
    var fontStyleStr=reviewFontSize?'font-size:'+reviewFontSize+'px;':'';
    var heroTitleSize=parseInt(s.heroTitleSize)||40;
    var heroTitleCase=s.heroTitleCase||'uppercase';
    var titleFontStyle=useHeadingFont?'font-size:'+heroTitleSize+'px;font-weight:900;text-transform:'+heroTitleCase+';letter-spacing:-1px;line-height:1.05;':'';
    function buildOneReview(r){
        var imgSrc=r.image||r.photo||'';
        var rawSize=r.imageSize&&r.imageSize!=='default'?r.imageSize:(s.defaultImageSize||'medium');
        var rawPos=r.imagePosition&&r.imagePosition!=='default'?r.imagePosition:(s.defaultImagePosition||'left');
        var layout=s.cardLayout||'default';
        var px=IMG_SIZE[rawSize]||130;
        // v2: per-card verified badge label (falls back to section-level label)
        var cardVerifiedLabel=r.verifiedBadgeLabel&&r.verifiedBadgeLabel.trim()?r.verifiedBadgeLabel:verifiedLabel;
        var verifiedBadge=r.verified!==false?'<span class="kb-review__verified-badge">&#10003; '+esc(cardVerifiedLabel)+'</span>':'';
        // v2: review headline
        var headlineHtml=r.headline?'<strong class="kb-review__headline">'+esc(r.headline)+'</strong>':'';
        var productHtml='';
        if(r.productName){
          var pImg=r.productImage?'<img src="'+esc(r.productImage)+'" alt="'+esc(r.productName)+'" class="kb-review__prod-img" loading="lazy">':'';
          var pPrice=r.productPrice?'<span class="kb-review__prod-price">'+esc(r.productPrice)+'</span>':'';
          var pOrig=r.productOriginalPrice?'<span class="kb-review__prod-orig">'+esc(r.productOriginalPrice)+'</span>':'';
          productHtml='<div class="kb-review__product">'+pImg+'<div class="kb-review__prod-details"><div class="kb-review__prod-name">'+esc(r.productName)+'</div><div class="kb-review__prod-prices">'+pPrice+pOrig+'</div></div></div>';
        }
        // v2: moonlightshop card hierarchy — row1: name(left)+date(right), row2: stars+verified, then headline, body, photo
        var dateFmt=r.date?'<span class="kb-review__date">'+esc(r.date)+'</span>':'';
        var gapStyle=innerGap!==8?'style="--kb-rg:'+innerGap+'px"':'';
        var nameRow='<div class="kb-review__name-row" '+gapStyle+'><span class="kb-review__name">'+esc(r.name)+'</span>'+dateFmt+'</div>';
        var metaRow='<div class="kb-review__meta-row" '+gapStyle+'><div class="kb-review__stars">'+renderStars(r.rating)+'</div>'+verifiedBadge+'</div>';
        var bodyStyle=fontStyleStr?(' style="'+fontStyleStr+'"'):'';
        var bodyBlock=headlineHtml+'<p class="kb-review__body"'+bodyStyle+'>'+esc(r.body)+'</p>'+productHtml;
        if(!imgSrc){
          return '<div class="kb-review">'+nameRow+metaRow+bodyBlock+'</div>';
        }
        if(rawPos==='top'||layout==='photo-card'){
          return '<div class="kb-review kb-review--photo-card">'+
            '<div class="kb-review__photo-top"><img src="'+esc(imgSrc)+'" alt="'+esc(r.name)+'" class="kb-review__photo-img" loading="lazy"></div>'+
            nameRow+metaRow+bodyBlock+'</div>';
        }
        var imgEl='<img src="'+esc(imgSrc)+'" alt="'+esc(r.name)+'" class="kb-review__img" loading="lazy" style="width:'+px+'px;height:'+px+'px;object-fit:cover;border-radius:8px;flex-shrink:0;border:1px solid var(--color-border,#333)">';
        var textBlock='<div class="kb-review__content">'+nameRow+metaRow+bodyBlock+'</div>';
        if(rawPos==='background'){
          return '<div class="kb-review kb-review--bg" style="background-image:url(\''+esc(imgSrc)+'\');background-size:cover;background-position:center">'+
            '<div class="kb-review__bg-overlay">'+nameRow+metaRow+bodyBlock+'</div></div>';
        }
        if(rawPos==='bottom'){return '<div class="kb-review">'+nameRow+metaRow+bodyBlock+'<div class="kb-review__img-wrap" style="margin-top:12px">'+imgEl+'</div></div>';}
        if(rawPos==='right'){return '<div class="kb-review kb-review--side">'+textBlock+'<div class="kb-review__img-wrap" style="margin-left:16px">'+imgEl+'</div></div>';}
        return '<div class="kb-review kb-review--side"><div class="kb-review__img-wrap" style="margin-right:16px">'+imgEl+'</div>'+textBlock+'</div>';
    }
    function buildReviewsHtml(){
      if(!stored.length)return '<div class="kb-reviews__empty"><p>Be the first to leave a review!</p></div>';
      var visible=stored.slice(0,kbVisibleCount);
      var cards=visible.map(buildOneReview).join('');
      var remaining=stored.length-kbVisibleCount;
      var btn=remaining>0
        ? '<div class="kb-reviews__show-more-wrap">'+
            '<button class="kb-reviews__show-more" id="kb-show-more-btn">'+
              'Show '+(Math.min(remaining,KB_PAGE_SIZE))+' more reviews'+
            '</button>'+
            '<span class="kb-reviews__count-label">'+kbVisibleCount+' of '+stored.length+'</span>'+
          '</div>'
        : (stored.length>KB_PAGE_SIZE?'<p class="kb-reviews__all-shown">All '+stored.length+' reviews shown</p>':'');
      return cards+btn;
    }
    var avg=stored.length?Math.round(stored.reduce(function(a,r){return a+r.rating},0)/stored.length*10)/10:0;
    var overallRating=s.overallRating||'';
    var totalReviews=s.totalReviews||'';
    var showOverallBadge=s.showOverallBadge!==false;
    var badgePosition=s.badgePosition||'above';
    var overallBadge=(showOverallBadge&&overallRating)?'<div class="kb-reviews__badge"><span class="kb-reviews__badge-stars">'+renderStars(5)+'</span> <span class="kb-reviews__badge-text">Rated <strong>'+esc(overallRating)+'</strong>'+(totalReviews?' based on <strong>+'+esc(totalReviews)+'</strong> reviews':'')+'</span></div>':'';
    // v2: grid layout class
    var gridClass=gridLayout==='grid-2'?'kb-reviews__list--grid-2':gridLayout==='grid-3'?'kb-reviews__list--grid-3':'';
    var alignStyle=sectionAlign!=='left'?'text-align:'+sectionAlign+';':'';
    var badgeHtml=overallBadge?(alignStyle?'<div style="'+alignStyle+'">':'')+overallBadge+(alignStyle?'</div>':''):'';
    shell.innerHTML=
      '<div class="kb-reviews">'+
        (badgePosition==='above'?badgeHtml:'')+
        '<div class="kb-reviews__header">'+
          '<div style="'+alignStyle+'flex:1">'+
            '<h2 class="kb-section-title" style="padding-top:0;'+titleFontStyle+'">'+title+'</h2>'+
            (subtitle?'<p class="kb-reviews__sub">'+subtitle+'</p>':'')+
          '</div>'+
          (s.showWriteReview!==false?'<button class="kb-reviews__write-btn" id="kb-write-review-btn">Write a Review</button>':'')+
        '</div>'+
        (badgePosition==='below'?badgeHtml:'')+
        '<div id="kb-write-review-form" class="kb-review-form" style="display:none">'+
          '<h3 class="kb-review-form__title">Write a Review</h3>'+
          '<div class="kb-review-form__stars" id="kb-star-select">'+
            [1,2,3,4,5].map(function(n){return '<button class="kb-star-btn" data-val="'+n+'" onclick="kbSetStar('+n+')">'+renderStars(n>0?n:0).split('</svg>')[0]+'</svg></button>'}).join('')+
          '</div>'+
          '<input id="kb-review-name" class="kb-review-form__input" placeholder="Your name" type="text">'+
          '<textarea id="kb-review-body" class="kb-review-form__input" placeholder="Share your experience..." rows="4"></textarea>'+
          '<label class="kb-review-form__photo-label">'+
            '<span>Add a photo (optional)</span>'+
            '<input id="kb-review-photo" class="kb-review-form__photo-input" type="file" accept="image/*">'+
          '</label>'+
          '<div id="kb-review-photo-preview" class="kb-review-form__photo-preview" style="display:none">'+
            '<img id="kb-review-photo-img" src="" alt="Preview">'+
            '<button type="button" class="kb-review-form__photo-remove" onclick="kbRemovePhoto()">✕ Remove</button>'+
          '</div>'+
          '<button class="kb-reviews__submit-btn" onclick="kbSubmitReview()">Submit Review</button>'+
          '<button class="kb-reviews__cancel-btn" onclick="document.getElementById(\'kb-write-review-form\').style.display=\'none\'">Cancel</button>'+
        '</div>'+
        '<div id="kb-reviews-list" class="kb-reviews__list'+( gridClass?' '+gridClass:'')+'">' +buildReviewsHtml()+'</div>'+
      '</div>';
    function wireShowMore(){
      var btn=document.getElementById('kb-show-more-btn');
      if(!btn)return;
      btn.addEventListener('click',function(){
        kbVisibleCount=Math.min(kbVisibleCount+KB_PAGE_SIZE,stored.length);
        document.getElementById('kb-reviews-list').innerHTML=buildReviewsHtml();
        wireShowMore();
      });
    }
    wireShowMore();
    var writeBtn=document.getElementById('kb-write-review-btn');
    if(writeBtn)writeBtn.addEventListener('click',function(){
      var form=document.getElementById('kb-write-review-form');
      form.style.display=form.style.display==='none'?'block':'none';
    });
    var selectedStar=5;
    var photoData=null;
    // Wire up photo input
    var photoInput=document.getElementById('kb-review-photo');
    if(photoInput){
      photoInput.addEventListener('change',function(){
        var file=photoInput.files[0];
        if(!file)return;
        var reader=new FileReader();
        reader.onload=function(ev){
          photoData=ev.target.result;
          var prev=document.getElementById('kb-review-photo-preview');
          var img=document.getElementById('kb-review-photo-img');
          if(prev&&img){img.src=photoData;prev.style.display='flex'}
        };
        reader.readAsDataURL(file);
      });
    }
    window.kbRemovePhoto=function(){
      photoData=null;
      var prev=document.getElementById('kb-review-photo-preview');
      if(prev)prev.style.display='none';
      if(photoInput)photoInput.value='';
    };
    window.kbSetStar=function(n){
      selectedStar=n;
      var btns=shell.querySelectorAll('.kb-star-btn');
      btns.forEach(function(b,i){b.style.opacity=i<n?'1':'0.35'});
    };
    window.kbSubmitReview=function(){
      var name=document.getElementById('kb-review-name').value.trim();
      var body=document.getElementById('kb-review-body').value.trim();
      if(!name||!body){alert('Please fill in your name and review.');return}
      var entry={name:name,rating:selectedStar,body:body};
      if(photoData)entry.photo=photoData;
      localReviews.unshift(entry);
      stored=adminReviews.concat(localReviews);
      try{localStorage.setItem('kb_reviews',JSON.stringify(localReviews))}catch(e){}
      kbVisibleCount=stored.length; // show all after submitting so user sees theirs
      document.getElementById('kb-reviews-list').innerHTML=buildReviewsHtml();
      wireShowMore();
      document.getElementById('kb-write-review-form').style.display='none';
      document.getElementById('kb-review-name').value='';
      document.getElementById('kb-review-body').value='';
      photoData=null;
      var prev=document.getElementById('kb-review-photo-preview');
      if(prev)prev.style.display='none';
      if(photoInput)photoInput.value='';
    };
  }

  /* ── Header ───────────────────────────────────────────────────────────── */
  function renderHeader(){
    var shell=document.getElementById('scaled-header-minimal');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="header-minimal"');
    if(!s)s={};
    var cfg=window.ScaledConfig||{};
    var brand=esc(cfg.brandName||'Store');
    var links='';
    for(var i=1;i<=6;i++){
      var t=s['nav_link_'+i+'_text'],u=s['nav_link_'+i+'_url'];
      if(t&&u)links+='<a href="'+esc(u)+'" class="kb-nav__link">'+esc(t)+'</a>';
    }
    var logoHtml=s.logo?'<img src="'+esc(s.logo)+'" alt="'+brand+'" class="kb-header__logo-img">':'<span class="kb-header__brand-text">'+brand+'</span>';
    shell.innerHTML=
      '<div class="kb-header">'+
        '<div class="kb-header__inner">'+
          '<a href="/" class="kb-header__logo">'+logoHtml+'</a>'+
          '<nav class="kb-nav">'+links+'</nav>'+
          '<div class="kb-header__actions">'+
            '<button class="kb-nav__toggle" id="kb-nav-toggle" aria-label="Menu"><span></span><span></span><span></span></button>'+
            '<a href="/cart" class="kb-header__cart" aria-label="Cart">'+
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>'+
              '<span class="kb-header__cart-count" id="kb-cart-count" style="display:none">0</span>'+
            '</a>'+
          '</div>'+
        '</div>'+
        '<nav class="kb-nav--mobile" id="kb-nav-mobile">'+links+'</nav>'+
      '</div>';
    shell.classList.remove('scaled-shell--loading');
    fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
      var el=document.getElementById('kb-cart-count');
      if(el&&c.item_count>0){el.textContent=c.item_count;el.style.display='flex'}
    }).catch(function(){});
    var btn=document.getElementById('kb-nav-toggle');
    var mob=document.getElementById('kb-nav-mobile');
    if(btn&&mob)btn.addEventListener('click',function(){var o=mob.classList.toggle('is-open');btn.classList.toggle('is-open',o)});
  }

  /* ── Product Grid ─────────────────────────────────────────────────────── */
  function renderProductGrid(){
    var shell=document.getElementById('scaled-product-grid');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="product-grid"');
    var products=getJson('data-scaled-products="product-grid"');
    if(!s)s={};
    if(!products)products=[];
    var cols=parseInt(s.products_per_row)||4;
    var headline=esc(s.hero_headline||'');
    var hw=s.highlight_word||'';
    if(hw&&headline){headline=headline.replace(new RegExp('('+esc(hw)+')','gi'),'<span class="kb-hero__hl">$1</span>')}
    var cards=products.map(function(p){
      var hasSale=p.comparePrice&&p.comparePrice>p.price;
      var bp=s.sale_badge_position||'top-right';
      return '<a href="'+esc(p.url)+'" class="kb-card">'+
        '<div class="kb-card__media">'+
          (p.image?'<img src="'+esc(p.image)+'" alt="'+esc(p.imageAlt||p.title)+'" class="kb-card__img" loading="lazy">':'<div class="kb-card__img-ph"></div>')+
          (hasSale?'<span class="kb-card__badge kb-card__badge--'+esc(bp)+'">'+esc(s.sale_badge_text||'SALE')+'</span>':'')+
        '</div>'+
        '<div class="kb-card__body">'+
          '<p class="kb-card__title">'+esc(p.title)+'</p>'+
          '<div class="kb-card__price">'+
            '<span class="kb-card__price-now">'+fmt(p.price)+'</span>'+
            (hasSale?'<span class="kb-card__price-was">'+fmt(p.comparePrice)+'</span>':'')+
          '</div>'+
        '</div>'+
        '<div class="kb-card__cta">'+esc(s.primary_button_text||'VIEW PRODUCT')+'</div>'+
      '</a>';
    }).join('');
    shell.innerHTML=
      '<div class="kb-product-section">'+
        (headline?'<div class="kb-hero"><h1 class="kb-hero__title">'+headline+'</h1></div>':'')+
        '<div class="kb-grid" style="--kb-cols:'+cols+'">'+
          (cards||'<p class="kb-grid__empty">No products found.</p>')+
        '</div>'+
      '</div>';
    shell.classList.remove('scaled-shell--loading');
  }


  /* ── Secondary Product Grid ───────────────────────────────────────────── */
  function renderSecondaryProductGrid(){
    var shell=document.getElementById('scaled-secondary-product-grid');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="secondary-product-grid"');
    var products=getJson('data-scaled-products="secondary-product-grid"');
    if(!s)s={};
    if(!products)products=[];
    var cols=parseInt(s.products_per_row)||4;
    var useHeadingStyle=s.use_heading_style===true;
    var headline=esc(s.headline||'');
    var hw=s.highlight_word||'';
    if(hw&&headline){headline=headline.replace(new RegExp('('+esc(hw)+')','gi'),'<span class="kb-hero__hl">$1</span>')}
    var subheadline=esc(s.subheadline||'');
    var cards=products.map(function(p){
      var hasSale=p.comparePrice&&p.comparePrice>p.price;
      var bp=s.sale_badge_position||'top-right';
      return '<a href="'+esc(p.url)+'" class="kb-card">'+
        '<div class="kb-card__media">'+
          (p.image?'<img src="'+esc(p.image)+'" alt="'+esc(p.imageAlt||p.title)+'" class="kb-card__img" loading="lazy">':'<div class="kb-card__img-ph"></div>')+
          (hasSale?'<span class="kb-card__badge kb-card__badge--'+esc(bp)+'">'+esc(s.sale_badge_text||'SALE')+'</span>':'')+
        '</div>'+
        '<div class="kb-card__body">'+
          '<p class="kb-card__title">'+esc(p.title)+'</p>'+
          '<div class="kb-card__price">'+
            '<span class="kb-card__price-now">'+fmt(p.price)+'</span>'+
            (hasSale?'<span class="kb-card__price-was">'+fmt(p.comparePrice)+'</span>':'')+
          '</div>'+
        '</div>'+
        '<div class="kb-card__cta">'+esc(s.primary_button_text||'VIEW PRODUCT')+'</div>'+
      '</a>';
    }).join('');
    shell.innerHTML=
      '<div class="kb-product-section">'+
        (headline?(useHeadingStyle?'<div class="kb-hero"><h2 class="kb-hero__title">'+headline+'</h2></div>':'<h2 class="kb-section-title">'+headline+'</h2>'):'')+
        (subheadline?'<p class="kb-section-subtitle">'+subheadline+'</p>':'')+
        '<div class="kb-grid" style="--kb-cols:'+cols+'">'+
          (cards||'<p class="kb-grid__empty">No products found.</p>')+
        '</div>'+
      '</div>';
    shell.classList.remove('scaled-shell--loading');
  }

  /* ── Footer ───────────────────────────────────────────────────────────── */
  function renderFooter(){
    var shell=document.getElementById('scaled-footer');
    if(!shell)return;
    var s=getJson('data-scaled-section-settings="footer"');
    if(!s)s={};
    var brand=esc(s.brandName||s.shopName||'Store');
    var year=s.year||new Date().getFullYear();
    var socials='';
    var sicons={instagram:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>',tiktok:'<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.16 8.16 0 004.77 1.52V6.76a4.85 4.85 0 01-1-.07z"/></svg>',discord:'<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03z"/></svg>'};
    if(s.instagramUrl)socials+='<a href="'+esc(s.instagramUrl)+'" class="kb-footer__social" target="_blank" rel="noopener" aria-label="Instagram">'+sicons.instagram+'</a>';
    if(s.tiktokUrl)socials+='<a href="'+esc(s.tiktokUrl)+'" class="kb-footer__social" target="_blank" rel="noopener" aria-label="TikTok">'+sicons.tiktok+'</a>';
    if(s.discordUrl)socials+='<a href="'+esc(s.discordUrl)+'" class="kb-footer__social" target="_blank" rel="noopener" aria-label="Discord">'+sicons.discord+'</a>';
    shell.innerHTML=
      '<div class="kb-footer">'+
        '<div class="kb-footer__inner">'+
          '<div class="kb-footer__top">'+
            '<div class="kb-footer__brand">'+
              (s.logoUrl?'<img src="'+esc(s.logoUrl)+'" alt="'+brand+'" class="kb-footer__logo">':'<span class="kb-footer__name">'+brand+'</span>')+
              (socials?'<div class="kb-footer__socials">'+socials+'</div>':'')+
            '</div>'+
            '<nav class="kb-footer__links">'+
              '<a href="/policies/privacy-policy" class="kb-footer__link">Privacy Policy</a>'+
              '<a href="/policies/terms-of-service" class="kb-footer__link">Terms of Service</a>'+
              '<a href="/policies/refund-policy" class="kb-footer__link">Refund Policy</a>'+
              '<a href="/collections/all" class="kb-footer__link">All Products</a>'+
            '</nav>'+
          '</div>'+
          '<div class="kb-footer__bottom">'+
            '<p class="kb-footer__copy">&copy; '+year+' '+brand+'. All rights reserved.</p>'+
          '</div>'+
        '</div>'+
      '</div>';
    shell.classList.remove('scaled-shell--loading');
  }

  /* ── Hide remaining empty shells ─────────────────────────────────────── */
  function hideOtherShells(){
    var keep=['scaled-header-minimal','scaled-footer','scaled-product-grid','scaled-secondary-product-grid','scaled-testimonials','scaled-trust-bar','scaled-urgency','scaled-faq','scaled-live-sales','scaled-reviews','scaled-chat'];
    document.querySelectorAll('.scaled-shell,.scaled-reviews-shell,.scaled-chat-shell,.scaled-urgency-shell,.scaled-trust-bar-shell,.scaled-testimonials-shell').forEach(function(el){
      if(keep.indexOf(el.id)===-1)el.style.display='none';
    });
  }


  /* ── AJAX Cart Drawer ─────────────────────────────────────────────────── */
  function initAjaxCart(){
    var modal=document.createElement('div');
    modal.id='kb-cart-modal';
    modal.className='kb-cart-modal';
    modal.innerHTML=
      '<div class="kb-cart-modal__overlay" id="kb-cart-overlay"></div>'+
      '<div class="kb-cart-modal__sheet">'+
        '<button class="kb-cart-modal__close" id="kb-cart-close" aria-label="Close">'+
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'+
        '</button>'+
        '<div class="kb-cart-modal__success" id="kb-cart-success">'+
          '<div class="kb-cart-modal__check">'+
            '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'+
          '</div>'+
          '<h2 class="kb-cart-modal__title">Added To Cart</h2>'+
          '<p class="kb-cart-modal__sub">Your item was added successfully.</p>'+
        '</div>'+
        '<div class="kb-cart-modal__items" id="kb-cart-items"></div>'+
        '<div class="kb-cart-modal__footer" id="kb-cart-foot" style="display:none">'+
          '<div class="kb-cart-modal__total">'+
            '<span>Total</span>'+
            '<strong id="kb-cart-total"></strong>'+
          '</div>'+
          '<button class="kb-cart-modal__btn kb-cart-modal__btn--secondary" id="kb-cart-continue">Continue Shopping</button>'+
          '<a href="/checkout" class="kb-cart-modal__btn kb-cart-modal__btn--primary">Checkout</a>'+
        '</div>'+
      '</div>';
    document.body.appendChild(modal);

    function closeModal(){modal.classList.remove('is-open');document.body.style.overflow=''}
    function openModal(){modal.classList.add('is-open');document.body.style.overflow='hidden'}

    document.getElementById('kb-cart-close').addEventListener('click',closeModal);
    document.getElementById('kb-cart-continue').addEventListener('click',closeModal);
    document.getElementById('kb-cart-overlay').addEventListener('click',closeModal);

    function renderCart(cart){
      var itemsEl=document.getElementById('kb-cart-items');
      var totalEl=document.getElementById('kb-cart-total');
      var foot=document.getElementById('kb-cart-foot');
      var success=document.getElementById('kb-cart-success');
      if(!cart.item_count){
        if(success)success.style.display='none';
        itemsEl.innerHTML='<div class="kb-cart-modal__empty"><p>Your cart is empty</p></div>';
        foot.style.display='none';
        return;
      }
      if(success)success.style.display='';
      itemsEl.innerHTML=cart.items.map(function(item){
        var vt=item.variant_title&&item.variant_title!=='Default Title'
          ?'<div class="kb-cart-item__variant">'+esc(item.variant_title)+'</div>':'';
        return '<div class="kb-cart-item">'+
          '<div class="kb-cart-item__img">'+
            (item.image?'<img src="'+esc(item.image)+'" alt="'+esc(item.product_title)+'" loading="lazy">':'')+
          '</div>'+
          '<div class="kb-cart-item__info">'+
            '<div class="kb-cart-item__title">'+esc(item.product_title)+'</div>'+
            vt+
            '<div class="kb-cart-item__qty-row">'+
              '<span class="kb-cart-item__qty-label">Quantity: '+item.quantity+'</span>'+
              '<span class="kb-cart-item__price">'+fmt(item.final_line_price)+'</span>'+
            '</div>'+
          '</div>'+
        '</div>';
      }).join('');
      if(totalEl)totalEl.textContent=fmt(cart.total_price);
      foot.style.display='flex';
      var badge=document.getElementById('kb-cart-count');
      if(badge){badge.textContent=cart.item_count;badge.style.display='flex'}
    }

    function fetchCart(){
      return fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
        .then(function(r){return r.json()})
        .then(function(cart){renderCart(cart);return cart});
    }

    document.addEventListener('submit',function(e){
      var form=e.target;
      if(!form||!form.getAttribute('action')||!form.getAttribute('action').includes('/cart/add'))return;
      e.preventDefault();
      e.stopPropagation();
      // Only touch the text span — never btn.textContent (that captures inline CSS from the spinner)
      var btn=form.querySelector('[name="add"],.product-form__submit');
      var btnTxtEl=btn?btn.querySelector('.product-form__submit-text'):null;
      var origTxt=btnTxtEl?btnTxtEl.textContent:'';
      if(btn)btn.disabled=true;
      if(btnTxtEl)btnTxtEl.textContent='Adding...';
      // Show loading state inside modal
      document.getElementById('kb-cart-success').style.display='none';
      document.getElementById('kb-cart-items').innerHTML=
        '<div class="kb-cart-modal__loading">'+
          '<div class="kb-cart-modal__spinner"></div>'+
        '</div>';
      document.getElementById('kb-cart-foot').style.display='none';
      openModal();
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'X-Requested-With':'XMLHttpRequest'},
        body:new FormData(form)
      })
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json()})
      .then(function(){return fetchCart()})
      .catch(function(){closeModal();form.submit()})
      .finally(function(){
        if(btn)btn.disabled=false;
        if(btnTxtEl)btnTxtEl.textContent=origTxt;
      });
    },true);
  }

  /* ── Run ──────────────────────────────────────────────────────────────── */
  /* ── Auto-inject shells from global data ─────────────────────────────── */
  function autoInjectFromGlobal(){
    var gd=getGlobalData();
    if(!gd||(!gd.reviews&&!gd.faqs&&!gd.testimonials))return;

    // Detect page type from body class (template-product, template-cart, template-index, etc.)
    var bodyClass=document.body.className||'';
    function onPage(name){return bodyClass.indexOf('template-'+name)!==-1}
    var isProduct=onPage('product');
    var isCart=onPage('cart');
    var isHome=onPage('index');

    // Find injection point — right after #main-content
    var main=document.getElementById('main-content');
    if(!main)return;

    // Helper: create a shell div and insert it after main (in order: testi → reviews → faq)
    function inject(id,cls,section){
      if(document.getElementById(id))return; // already on page
      var el=document.createElement('div');
      el.id=id;
      el.className=cls;
      el.setAttribute('data-scaled-section',section);
      main.parentNode.insertBefore(el,main.nextSibling);
    }

    // Reviews + FAQ → product page and cart page
    if(isProduct||isCart){
      var hasReviews=gd.reviews&&gd.reviews.items&&gd.reviews.items.length;
      var hasFaqs=gd.faqs&&gd.faqs.length;
      // Inject in reverse order so they end up: reviews then faq (insertBefore(main.nextSibling) prepends)
      if(hasFaqs)inject('scaled-faq','scaled-shell scaled-shell--loading','faq');
      if(hasReviews)inject('scaled-reviews','scaled-reviews-shell','reviews');
    }

    // Testimonials → product page only (home page already has the shell section added manually)
    if(isProduct){
      var hasTesti=gd.testimonials&&gd.testimonials.length;
      if(hasTesti)inject('scaled-testimonials','scaled-testimonials-shell','testimonials');
    }
  }

  function safe(fn){try{fn();}catch(e){}}
  function run(){
    safe(autoInjectFromGlobal);
    safe(renderHeader);
    safe(renderUrgency);
    safe(renderTrustBar);
    safe(renderProductGrid);
    safe(renderSecondaryProductGrid);
    safe(renderTestimonials);
    safe(renderFaq);
    safe(renderReviews);
    safe(renderFooter);
    safe(renderLiveSales);
    safe(renderChat);
    safe(initAjaxCart);
    safe(hideOtherShells);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',run);
  }else{
    run();
  }

  // Theme editor: re-render urgency + trust bar when settings change
  ['shopify:section:load','shopify:section:select','shopify:block:select','shopify:block:deselect'].forEach(function(ev){
    document.addEventListener(ev,function(){
      safe(renderUrgency);
      safe(renderTrustBar);
    });
  });

  // MutationObserver fallback: re-render when Shopify replaces the section DOM
  if(window.MutationObserver){
    new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        var added=muts[i].addedNodes;
        for(var j=0;j<added.length;j++){
          var n=added[j];
          if(n.nodeType!==1)continue;
          if(n.id==='scaled-urgency'||(n.querySelector&&n.querySelector('#scaled-urgency'))){safe(renderUrgency);}
          if(n.id==='scaled-trust-bar'||(n.querySelector&&n.querySelector('#scaled-trust-bar'))){safe(renderTrustBar);}
        }
      }
    }).observe(document.body,{subtree:true,childList:true});
  }
})();
